
/// <amd-module name="Search/Shared/Components/ExtendedSearchSection/ExtendedSearchSection.Props" />
import { ObservableValue, IObservableValue } from "VSS/Core/Observable";
import { IVssPageContext } from "VSS/Platform/Context";
import { IProjectData } from "Tfs/Platform/Page";


export interface IExtendedSearchSectionProps {
    className: string;

    pageContext: IVssPageContext;

    defaultSearchText: ObservableValue<string | undefined>;

    selectedTabId: IObservableValue<string>;

    project: IProjectData | undefined;
}